import styled from "styled-components";


type Props = {
  $responsive?: boolean
  $list?: boolean
}


export default styled.ul<Props>`
  font-family: "Major Mono Display", monospace;
  font-weight: 400;
  font-style: normal;
  font-size: 2rem;
  margin: 0 1rem 1rem 0;
  padding: 0;
  color: #302418;
  user-select: none;
  width: 100%;
  & ::selection { 
    background: #302418;
    color: #e6a203;
  }


  & + & {
    border-top: 1px solid #333333;
    padding-top: 1rem;
    font-size: 1.2rem;
  }

  & h2 {
    font-weight: 400;
    margin: 0 0 0 0;
    padding: 0 0 0 0;
    font-size: 2rem;
    letter-spacing: -3px;
    font-weight: bold;
    text-transform: lowercase;
  }
  & h3 {
    font-weight: 400;
    margin: 0 0 1rem 0;
    padding: 0 0 2rem 0;
    border-bottom: 1px solid #333333;
    font-size: 1.05rem;
    letter-spacing: 0;
    font-weight: bold;
    text-transform: lowercase;
    white-space: nowrap;
  }

  @media screen and (max-width: 1260px) {
      & + & {
        border: 0;
      }
    }
       
    ${({ $list = true }) => $list && `
      display: flex;
      flex-direction: column;
    `}
    
  ${({ $responsive = true }) => $responsive && `
      @media screen and (max-width: 1260px) {
        display: flex;
        flex-direction: row;
        margin: 0;
        justify-content: space-between;

        & h2, & h3 {
          margin:0;
          margin-right: 2rem;
          border: 0;
          padding: 0;
        }

        & + & {
          margin: 0;
          border: 0;
          padding: 0;
          display: flex;
          justify-content: flex-end;
        }
      }

      @media screen and (max-width: 920px) {

      }

      @media screen and (max-width: 740px) {

      }

      @media screen and (max-width: 390px) {

      }
  `}
`